var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-2918d5ba-026f-4d3c-92f4-40146c941123",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-de684f5b-e01e-4de6-9511-f60667b27dbc",
    d: "M11.96,22.96c-.55,0-1-.45-1-1v-2.78c0-.55.45-1,1-1s1,.45,1,1v2.78c0,.55-.45,1-1,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-de684f5b-e01e-4de6-9511-f60667b27dbc",
    d: "M16,14.91c-.55,0-1-.45-1-1v-3.88c0-.55.45-1,1-1s1,.45,1,1v3.88c0,.55-.45,1-1,1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-de684f5b-e01e-4de6-9511-f60667b27dbc",
    d: "M16,22.96c-.55,0-1-.45-1-1v-.84c0-.55.45-1,1-1s1,.45,1,1v.84c0,.55-.45,1-1,1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-de684f5b-e01e-4de6-9511-f60667b27dbc",
    d: "M20.04,22.96c-.55,0-1-.45-1-1v-3.91c0-.55.45-1,1-1s1,.45,1,1v3.91c0,.55-.45,1-1,1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-de684f5b-e01e-4de6-9511-f60667b27dbc",
    d: "M20.04,11.66c-.55,0-1-.45-1-1v-.62c0-.55.45-1,1-1s1,.45,1,1v.62c0,.55-.45,1-1,1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-de684f5b-e01e-4de6-9511-f60667b27dbc",
    d: "M11.96,13.03c-.55,0-1-.45-1-1v-2c0-.55.45-1,1-1s1,.45,1,1v2c0,.55-.45,1-1,1Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-de684f5b-e01e-4de6-9511-f60667b27dbc",
    cx: 16,
    cy: 17.53,
    r: 1.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-de684f5b-e01e-4de6-9511-f60667b27dbc",
    cx: 20.04,
    cy: 14.36,
    r: 1.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-de684f5b-e01e-4de6-9511-f60667b27dbc",
    cx: 11.96,
    cy: 15.61,
    r: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.719b230443fe0cb5b8c7faea4bf33808.svg";
export { ForwardRef as ReactComponent };